import { notification } from 'antd'
import { ReactComponent as Close24 } from '../../assets/svg/Close24.svg'
import { ReactComponent as Information24 } from '../../assets/svg/Information24.svg'
import { TNotification } from './types'
import './notification.info.scss'

export const Info = ({
  description,
  duration = 5,
  top = 40,
  message,
  placement = 'topRight',
  btn,
  ...props
}: TNotification): void => {
  notification.info({
    icon: <Information24 />,
    closeIcon: <Close24 />,
    btn,
    placement,
    top,
    duration,
    message,
    description,
    ...props
  })
}
